import React from 'react'
import GlobalErrorModal from '../components/molecules/global-error-modal/global-error-modal'

const RootWrapper = ({ children }) => (
	<>
		{children}
		<GlobalErrorModal />
	</>
)

export const wrapRootElement = ({ element }) => (
	<RootWrapper>{element}</RootWrapper>
)
